import { defineStore } from 'pinia'
import { faqService } from '@/services/faqService'
import errorService from '@/services/errorService';

export const useFaqStore = defineStore('faq', {
  state: () => ({
    faqs: {
      meta: {}
    },
    faq: {},
    filter: {},
    reply: {},
  }),

  actions: {
    async getFaqs() {
      try {
        const response = await faqService.fetchFaqs(this.filter);
        this.faqs = response.data;
      } catch (error) {
        return errorService.handle(error);
      }
    },

    async getFaq(id) {
      try {
        const response = await faqService.fetchFaq(id);
        this.faq = response.data.data;

      } catch (error) {
        return errorService.handle(error);
      }
    },
  }
});